import { Input, InputGroup, InputProps, InputRightElement, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { MdError } from "react-icons/md";

export interface InputWithErrorMessageType extends InputProps {
    placeholder: string;
    errorMessage: string;
    value: string;
    required?: boolean;
    validationPattern?: RegExp;
    compare?: string;
    onChange: (e: any) => void;
    errorStatus?: (e: any) => void;
}

function ErrorToolTip({ errorMessage }: { errorMessage: string }) {
    return (
        <Tooltip
            py={2}
            hasArrow
            bg='red.400'
            rounded={'md'}
            placement="right"
            label={errorMessage}
        >
            <InputRightElement
                color={'red.400'}
                top={'3px'}
                children={<MdError size={'20px'} />}
            />
        </Tooltip>
    )
}

export default function InputWithErrorMessage(props: InputWithErrorMessageType) {
    const [errored, isErrored] = useState(false);

    function onBlur(e: any) {
        if (props.required && e.target.value === "") {
            isErrored(true);
            return;
        }

        if (props.compare && (props.compare !== e.target.value)) {
            isErrored(true);
            return;
        }
        if (props.validationPattern) {
            let pattern = new RegExp(props.validationPattern);
            isErrored(!pattern.test(e.target.value));
            return;
        }

        isErrored(false);
    }

    useEffect(() => {
        if (props.errorStatus) {
            props.errorStatus(errored);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errored])

    let style: InputWithErrorMessageType = {
        onBlur,
        ...props
    };
    if (errored) {
        style = {
            ...style,
            borderColor: 'red.400',
            borderWidth: '2px',
            _hover: {
                borderColor: 'red.400'
            },
            _focus: {
                borderColor: 'red.400',
                boxShadow: 'none'
            },
        }
    }

    return (
        <InputGroup>
            {
                errored ?
                    (
                        <ErrorToolTip errorMessage={props.errorMessage} />
                    )
                    :
                    (
                        <></>
                    )
            }
            <Input
                type={"text"}
                size={"lg"}
                p={3}
                fontSize={"14px"}
                fontWeight={"400"}
                w={"full"}
                {...style}
            />
        </InputGroup>
    );
}